<template>
	<img
		class="heading heading-svg" :src="require('@/assets/images/headings/' + imgName + '.svg')"
		:alt="altText"
	/>
</template>

<script>
export default {
	name: 'HeadingSVG',
	props: {
		altText: {
			type: String,
			required: true,
		},
		imgName: {
			type: String,
			required: true,
		},
	},
};
</script>

<style lang="scss" scoped>
	.heading {
		width: 80%;
		max-height: 65px;
		margin: 40px 0;

		@include mobile { margin: 30px 0 20px; }
		@include desktop-lg { max-height: 85px; }

		&.unfixed {
			position: relative;
			margin: 0 0 20px;
		}
	}
</style>
